export default {
    intro: '根据声母、释义、例句等线索，<br />推理出是什么单词吧！',
    word: '单词', meaning: '释义', example: '例', resources: '资料',
    teacherFooter: { left: '请从左侧题目中选择单词。' },
    table: { question: '题目', emptyMessage: '没有内容。' },
};
